import React, { FunctionComponent, MutableRefObject } from 'react';
import { UseFormRegister } from 'react-hook-form';

import { RadioCard } from '../../RadioCard';
import { RadioCardProps } from '../../RadioCard/RadioCard';

function mergeRefs(
  refs: Array<
    | MutableRefObject<HTMLInputElement | null>
    | ((instance: HTMLInputElement | null) => void)
    | null
  >,
): React.RefCallback<HTMLInputElement | null> {
  return (value) => {
    refs.forEach((ref) => {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref !== null) {
        ref.current = value;
      }
    });
  };
}

interface RadioButtonHookFormProps extends Exclude<RadioCardProps, 'onChange'> {
  register: UseFormRegister<any>;
  name: string;
}
interface RadioButtonHookFormPWithRef extends RadioButtonHookFormProps {
  forwardedRef:
    | MutableRefObject<HTMLInputElement | null>
    | ((instance: HTMLInputElement | null) => void)
    | null;
}

const RadioButtonHookForm: FunctionComponent<
  React.PropsWithChildren<RadioButtonHookFormPWithRef>
> = ({ register, name, forwardedRef, ...rest }) => {
  const { ref, ...resgisteredInput } = register(name);

  return (
    <RadioCard
      {...rest}
      {...resgisteredInput}
      ref={mergeRefs([ref, forwardedRef])}
    />
  );
};

RadioButtonHookForm.displayName = 'RadioButtonHookForm';

export default React.forwardRef<HTMLInputElement, RadioButtonHookFormProps>(
  (props, ref) => <RadioButtonHookForm forwardedRef={ref} {...props} />,
);
